import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import ReverseService from "../services/ReverseService";
import CollectOrderService from "../services/CollectOrderService";
import { FaCircle } from "react-icons/fa";
import InitiateReverseModal from "./modals/Reverse/InitiateReverseModal";
import TiposColeta from './../enums/TiposColeta';
import InitiateSingleCollectOrderModal from "./modals/Reverse/InitiateSingleCollectOrderModal";
import GenerateGEModal from "./modals/Reverse/GenerateGEModal";
import exportToExcelCollectOrders from './../utils/exportToExcelCollectOrders';
import { FaFileExcel } from "react-icons/fa";
import StatusCollectOrders from "../enums/StatusCollectOrders";
import CollectOrderDetailsModal from "./modals/Reverse/CollectOrderDetailsModal";
import CancelCollectOrderModal from "./modals/Reverse/CancelCollectOrderModal";
import { parseISO, format as formatDate } from "date-fns";
import { ehUsuarioInterno } from "../utils/roles";

export default function MyReverses() {
  const { user } = useOutletContext();

  const statusColor = {
    "ATIVO": "#0369a1",
    "PENDENTE": "#fde047",
    "ABERTO": "#fde047",
    "EM ANDAMENTO": "#38bdf8",
    "TRIAGEM": "#22c55e",
    "REPASSE PARA COLETA": "#bae6fd",
    "ROTA DE COLETA": "#38bdf8",
  };

  const [reverseList, setReverseList] = useState([]);
  const [collectOrdersList, setCollectOrdersList] = useState([]);
  const [initiateReverseModal, setInitiateReverseModal] = useState(false);
  const [reverseOnAnswerModal, setReverseOnAnswerModal] = useState();
  const [initiateSingleCollectModal, setInitiateSingleCollectModal] = useState(false);
  const [generateGEModal, setGenerateGEModal] = useState(false);
  const [collectOrderOnGenerateGEModalModal, setCollectOrderOnGenerateGEModalModal] = useState();
  const [collectOrderDetailsModal, setCollectOrderDetailsModal] = useState(false);
  const [collectOrderOnDetailsModal, setCollectOrderOnDetailsModal] = useState();
  const [cancelModal, setCancelModal] = useState(false);
  const [collectOrderOnCancelModal, setCollectOrderOnCancelModal] = useState();

  // Minhas Coletas
  const [myCollectsList, setMyCollectsList] = useState({ collectOrders: [], totalPages: 1, totalCollectOrders: 0 });
  const [currentPageMyCollects, setCurrentPageMyCollects] = useState(1);
  // Tipo de relatório: 'my' ou 'team'
  const [reportType, setReportType] = useState('my');
  // Filtro de status
  const [statusFilter, setStatusFilter] = useState('');
  // Filtro de data para Minhas Coletas
  const getDefaultDateRange = () => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 29); // últimos 30 dias (inclui hoje)
    return {
      start: start.toISOString().slice(0, 10),
      end: end.toISOString().slice(0, 10),
    };
  };
  const [dateRange, setDateRange] = useState(getDefaultDateRange());
  const [tempDateRange, setTempDateRange] = useState(getDefaultDateRange());

  // Buscar Minhas Coletas apenas ao clicar em Buscar
  const [shouldFetchCollects, setShouldFetchCollects] = useState(false);
  useEffect(() => {
    if (!shouldFetchCollects) return;
    const fetchCollects = async () => {
      let filter = `?startDate=${dateRange.start}&endDate=${dateRange.end}`;
      if (statusFilter) filter += `&status=${encodeURIComponent(statusFilter)}`;
      let result;
      if (reportType === 'my') {
        result = await CollectOrderService.getMyCollectOrders(filter, 1, 10, false);
      } else {
        result = await CollectOrderService.getMyTeamCollectOrders(filter, 1, 10, false);
      }
      setMyCollectsList(result || { collectOrders: [], totalPages: 1, totalCollectOrders: 0 });
      setCurrentPageMyCollects(1);
      setShouldFetchCollects(false);
    };
    fetchCollects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchCollects]);

  const handleDateRangeSearch = async () => {
    setDateRange({ ...tempDateRange });
    setShouldFetchCollects(true);
  };

  const handlePageChangeMyCollects = async (newPage) => {
    if (myCollectsList?.totalPages && newPage >= 1 && newPage <= myCollectsList.totalPages) {
      let filter = `?startDate=${dateRange.start}&endDate=${dateRange.end}`;
      if (statusFilter) filter += `&status=${encodeURIComponent(statusFilter)}`;
      let result;
      if (reportType === 'my') {
        result = await CollectOrderService.getMyCollectOrders(filter, newPage, 10, false);
      } else {
        result = await CollectOrderService.getMyTeamCollectOrders(filter, newPage, 10, false);
      }
      setMyCollectsList(result || { collectOrders: [], totalPages: 1, totalCollectOrders: 0 });
      setCurrentPageMyCollects(newPage);
    }
  };

  // Filtro de pesquisa
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState('');

  // Paginação (opcional, pode remover se não for mais necessário)
  const [currentPageReverses, setCurrentPageReverses] = useState(1);
  const [currentPageCollectOrders, setCurrentPageCollectOrders] = useState(1);

  // Buscar reversa e coletas relacionadas
  const fetchReversesAndCollects = async (searchValue) => {
    if (!searchValue) {
      setReverseList([]);
      setCollectOrdersList([]);
      return;
    }
    const reverses = await ReverseService.getMyTeamReverses(`?search=${searchValue}`, 1);
    setReverseList(reverses);

    const collectOrders = await CollectOrderService.getMyTeamCollectOrders(`?search=${searchValue}`, 1);
    setCollectOrdersList(collectOrders);
  };

  // Handlers do filtro
  // const handleSearchChange = (e) => {
  //   setTempSearch(e.target.value);
  // };

  const handleSearchBlur = () => {
    setSearch(tempSearch);
    fetchReversesAndCollects(tempSearch);
    setCurrentPageReverses(1);
    setCurrentPageCollectOrders(1);
  };

  // const handleSearchKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     setSearch(tempSearch);
  //     fetchReversesAndCollects(tempSearch);
  //     setCurrentPageReverses(1);
  //     setCurrentPageCollectOrders(1);
  //   }
  // };

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setReverseList([]);
    setCollectOrdersList([]);
    setCurrentPageReverses(1);
    setCurrentPageCollectOrders(1);
  };

  const handlePageChangeReverses = (newPage) => {
    if (reverseList?.totalPages && newPage >= 1 && newPage <= reverseList.totalPages) {
      setCurrentPageReverses(newPage);
      fetchReversesAndCollects(search);
    }
  };

  const handlePageChangeCollectOrders = (newPage) => {
    if (collectOrdersList?.totalPages && newPage >= 1 && newPage <= collectOrdersList.totalPages) {
      setCurrentPageCollectOrders(newPage);
      fetchReversesAndCollects(search);
    }
  };

  const handleInitiateReverse = async (reverse) => {
    if (reverse && reverse?.request?.status !== 'FINALIZADO') {
      const confirm = window.confirm('A solicitação ainda não está finalizado. Deseja continuar mesmo assim?');
      if (!confirm) return;
    }
    setReverseOnAnswerModal(reverse._id);
    setInitiateReverseModal(true);
  };

  const handleCollectOrderGE = async (collectOrderId) => {
    setGenerateGEModal(true);
    setCollectOrderOnGenerateGEModalModal(collectOrderId);
  };

  const getDescricaoByCod = (cod) => {
    const tipo = TiposColeta.find(item => item.cod === cod);
    return tipo ? tipo.descricao : 'Código não encontrado';
  };

  const handleExportToExcel = async () => {
    let filter = `?startDate=${dateRange.start}&endDate=${dateRange.end}`;
    if (statusFilter) filter += `&status=${encodeURIComponent(statusFilter)}`;
    let cOrdersExcel;
    if (reportType === 'my') {
      cOrdersExcel = await CollectOrderService.getMyCollectOrders(filter, 1, 0, true);
    } else {
      cOrdersExcel = await CollectOrderService.getMyTeamCollectOrders(filter, 1, 0, true);
    }
    exportToExcelCollectOrders(cOrdersExcel?.collectOrders || []);
  };

  const handleCollectOrderDetailsModal = async (cOrderId) => {
    setCollectOrderDetailsModal(true);
    setCollectOrderOnDetailsModal(cOrderId);
  };

  const handleCancel = async (requestId) => {
    setCancelModal(true);
    setCollectOrderOnCancelModal(requestId);
  };

  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">
      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-2 bg-white">
        {/* CONTAINER 1: FILTRO + REVERSAS + ORDENS DE COLETA */}
        <div className="flex flex-col gap-6 border-2 border-gray-800 border-opacity-70 rounded-2xl p-2 bg-white mb-6 shadow-xl">
          {/* FILTRO DE PESQUISA */}
          <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
            <div className="flex space-x-4 text-[12px]">
              <div className="flex flex-col">
                <label className="font-semibold ms-2">Pesquisar</label>
                <input
                  type="text"
                  placeholder="Pesquisar por número da reversa"
                  value={tempSearch}
                  onChange={(e) => setTempSearch(e.target.value)}
                  onBlur={handleSearchBlur}
                  className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                />
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setSearch(tempSearch);
                  fetchReversesAndCollects(tempSearch);
                  setCurrentPageReverses(1);
                  setCurrentPageCollectOrders(1);
                }}
                className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40"
              >
                Buscar
              </button>
              <button
                onClick={clearFilters}
                className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40"
              >
                Limpar Filtros
              </button>
            </div>
          </div>

          {/* TABELA REVERSAS */}
          <div className="flex flex-col gap-2 rounded-xl">
            <div className="w-full text-md font-semibold">
              Coletas Pendentes
            </div>
            <div className="w-full flex flex-col gap-4">
              <div className="w-full">
                <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{reverseList?.totalReverses ? reverseList?.totalReverses : '0'} registros</div></div>
                <div className="overflow-x-auto min-h-48">
                  <table className="min-w-full bg-white rounded-lg text-[10px]">
                    <thead className="bg-yellow-100">
                      <tr>
                        <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                        <th className="py-2 px-4 border-b">Solicitação Ref</th>
                        <th className="py-2 px-4 border-b">Status Solicitação</th>
                        <th className="py-2 px-4 border-b">Criado em</th>
                        <th className="py-2 px-4 border-b">GMO</th>
                        <th className="py-2 px-4 border-b">Cod Sap</th>
                        <th className="py-2 px-4 border-b">Equipamento</th>
                        <th className="py-2 px-4 border-b">Qtdade Pedido</th>
                        <th className="py-2 px-4 border-b">Resta Coletar</th>
                        <th className="py-2 px-4 border-b">Quantidade Aceita</th>
                        <th className="py-2 px-4 border-b">Quantidade Rejeitada</th>
                        <th className="py-2 px-4 border-b">Coletas Abertas</th>
                        <th className="py-2 px-4 border-b">Contato</th>
                        <th className="py-2 px-4 border-b">Telefone</th>
                        <th className="py-2 px-4 border-b">Iniciar Coleta Até</th>
                        <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reverseList?.reverses?.map((reverse, index) => (
                        <tr key={index} className="border-b hover:bg-gray-100">
                          <td className="py-1 px-4">
                            <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                              <FaCircle color={statusColor[reverse?.status]} size={15} />
                              {reverse?.status}
                            </div>
                          </td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.request?.idRequest}</div></td>
                          <td className="py-1 px-4">{reverse?.request?.status}</td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{formatDate(parseISO(reverse?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                          <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-start items-center gap-2">{reverse.gmo.cidade === "SÃO PAULO" ? `SP - ${reverse.gmo.identificador}` : `${reverse.gmo.cidade}`}</div></td>
                          <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{reverse?.codSap}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{reverse?.request?.nomeEquipamento}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.quantidade}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.quantidadeRestante}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.quantidadeAceita}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.quantidadeRejeitada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.collectOrders.length}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.user.name}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.user.phone}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{reverse?.slaDateReverse ? formatDate(parseISO(reverse.slaDateReverse), 'dd/MM/yy HH:mm') : ""}</div></td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center gap-2 h-5 text-[11px]">
                              <button
                                disabled={(reverse?.quantidadeRestante <= 0 || reverse?.status === 'ENCERRADO' || reverse?.status === 'CANCELADO')}
                                className="rounded-full px-2 text-white whitespace-nowrap bg-gray-700 disabled:bg-gray-300"
                                onClick={() => handleInitiateReverse(reverse)}
                              >
                                Iniciar Coleta
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Paginação Reversas - padrão ConsultaGerencialAtendimento */}
                <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                  <button
                    onClick={() => handlePageChangeReverses(currentPageReverses - 1)}
                    disabled={currentPageReverses === 1}
                    className={`px-2 py-1 rounded-md ${currentPageReverses === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                  >
                    {'<'}
                  </button>
                  {/* Primeira página */}
                  {currentPageReverses > 2 && (
                    <>
                      <button
                        onClick={() => handlePageChangeReverses(1)}
                        className="px-2 py-1 rounded-md bg-gray-300"
                      >
                        1
                      </button>
                      {currentPageReverses >= 3 && <span className="px-2 py-1">...</span>}
                    </>
                  )}
                  {/* Botões ao redor da página atual */}
                  {Array.from({ length: 3 }, (_, i) => {
                    const page = currentPageReverses - 1 + i;
                    if (page > 0 && page <= (reverseList?.totalPages || 1)) {
                      return (
                        <button
                          key={page}
                          onClick={() => handlePageChangeReverses(page)}
                          className={`px-2 py-1 rounded-md ${page === currentPageReverses ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                        >
                          {page}
                        </button>
                      );
                    }
                    return null;
                  })}
                  {/* Última página */}
                  {currentPageReverses < (reverseList?.totalPages || 1) - 1 && (
                    <>
                      {currentPageReverses < (reverseList?.totalPages || 1) - 2 && <span className="px-2 py-1">...</span>}
                      <button
                        onClick={() => handlePageChangeReverses(reverseList?.totalPages || 1)}
                        className="px-2 py-1 rounded-md bg-gray-300"
                      >
                        {reverseList?.totalPages || 1}
                      </button>
                    </>
                  )}
                  <button
                    onClick={() => handlePageChangeReverses(currentPageReverses + 1)}
                    disabled={currentPageReverses === (reverseList?.totalPages || 1)}
                    className={`px-2 py-1 rounded-md ${currentPageReverses === (reverseList?.totalPages || 1) ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                  >
                    {'>'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* TABELA ORDENS DE COLETA */}
          <div className="flex flex-col gap-2 rounded-xl">
            <div className="flex justify-between w-full">
              <div className="text-md font-semibold">Ordens de Coletas Ativas</div>
              <div className="flex gap-2">
                {user.role !== 'tecnico' &&
                  <button
                    className="bg-blue-600 rounded-full px-2 text-white whitespace-nowrap"
                    onClick={() => setInitiateSingleCollectModal(true)}
                  >
                    +Coleta Avulsa
                  </button>
                }
                {/* <button
                  onClick={() => handleExportToExcel(collectOrdersList?.collectOrders)}
                  className="bg-green-600 rounded-full px-2 text-white whitespace-nowrap flex items-center gap-2"
                >
                  <FaFileExcel />
                  <div>Exportar</div>
                </button> */}
              </div>
            </div>
            <div className="w-full">
              <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{collectOrdersList?.totalCollectOrders} registros</div></div>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-blue-100">
                    <tr>
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID Coleta</th>
                      <th className="py-2 px-4 border-b">Solicitação Ref</th>
                      <th className="py-2 px-4 border-b">Tipo Coleta</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">GMO</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Equipamento</th>
                      <th className="py-2 px-4 border-b">Qtdade Coleta</th>
                      <th className="py-2 px-4 border-b">Endereço</th>
                      <th className="py-2 px-4 border-b">Complemento</th>
                      <th className="py-2 px-4 border-b">Contato</th>
                      <th className="py-2 px-4 border-b">Telefone</th>
                      <th className="py-2 px-4 border-b">SLA Coleta</th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {collectOrdersList?.collectOrders?.map((collectOrder, index) => (
                      <tr key={index} className="border-b hover:bg-gray-100">
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                            <FaCircle
                              className="animate-pulse"
                              color={StatusCollectOrders[`${collectOrder?.status}`]?.cor}
                              size={15}
                            />
                            {collectOrder?.status}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={() => handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder?.idCollectOrder}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest ? collectOrder?.idRequest : 'AVULSO'}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{getDescricaoByCod(collectOrder?.tipoColeta)}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{formatDate(parseISO(collectOrder?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder.gmo.cidade === "SÃO PAULO" ? `SP - ${collectOrder.gmo.identificador}` : `${collectOrder.gmo.cidade}`}</div></td>
                        <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{collectOrder?.codEquipamentoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.nomeEquipamentoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColetaComplemento}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.nomeSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.contatoSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.slaCollectDate ? formatDate(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : ""}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">
                          <button
                            className="bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                            onClick={() => { handleCollectOrderGE(collectOrder._id) }}
                          >
                            Gerar GE
                          </button>
                          {collectOrder?.status === 'ABERTO' && ehUsuarioInterno(user) &&
                            <button
                              className="bg-amber-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => handleCancel(collectOrder._id)}
                            >
                              Cancelar
                            </button>
                          }
                        </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Paginação Coletas - padrão ConsultaGerencialAtendimento */}
              <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChangeCollectOrders(currentPageCollectOrders - 1)}
                  disabled={currentPageCollectOrders === 1}
                  className={`px-2 py-1 rounded-md ${currentPageCollectOrders === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>
                {/* Primeira página */}
                {currentPageCollectOrders > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChangeCollectOrders(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageCollectOrders >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}
                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageCollectOrders - 1 + i;
                  if (page > 0 && page <= (collectOrdersList?.totalPages || 1)) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChangeCollectOrders(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageCollectOrders ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}
                {/* Última página */}
                {currentPageCollectOrders < (collectOrdersList?.totalPages || 1) - 1 && (
                  <>
                    {currentPageCollectOrders < (collectOrdersList?.totalPages || 1) - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChangeCollectOrders(collectOrdersList?.totalPages || 1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {collectOrdersList?.totalPages || 1}
                    </button>
                  </>
                )}
                <button
                  onClick={() => handlePageChangeCollectOrders(currentPageCollectOrders + 1)}
                  disabled={currentPageCollectOrders === (collectOrdersList?.totalPages || 1)}
                  className={`px-2 py-1 rounded-md ${currentPageCollectOrders === (collectOrdersList?.totalPages || 1) ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>
            </div>
          </div>

          

        </div>

        {/* CONTAINER 2: MINHAS COLETAS */}
        <div className="flex flex-col gap-2 rounded-2xl p-4 border-2 border-zinc-700 bg-blue-100 shadow-xl">
          <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
            {/* Dropdown Tipo de Relatório e Status */}
            <div className="flex flex-row gap-2">
              <div className="flex flex-col">
                <label className="font-semibold ms-2">Tipo de Relatório</label>
                <select
                  className="block w-48 h-5 rounded-2xl px-4 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0 text-xs"
                  value={reportType}
                  onChange={e => setReportType(e.target.value)}
                >
                  <option value="my">Minhas Coletas</option>
                  <option value="team">Coletas da Empresa</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label className="font-semibold ms-2">Status</label>
                <select
                  className="block w-40 h-5 rounded-2xl px-4 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0 text-xs"
                  value={statusFilter}
                  onChange={e => setStatusFilter(e.target.value)}
                >
                  <option value="">Todos</option>
                  {Object.entries(StatusCollectOrders).map(([key, value]) => (
                    <option key={key} value={key}>{value.descricao}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex space-x-4 text-[12px]">
              <div className="flex flex-col">
                <label className="font-semibold ms-2">Data início</label>
                <input
                  type="date"
                  className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0 text-xs"
                  value={tempDateRange.start}
                  max={tempDateRange.end}
                  onChange={e => setTempDateRange(r => ({ ...r, start: e.target.value }))}
                />
              </div>
              <div className="flex flex-col">
                <label className="font-semibold ms-2">Data fim</label>
                <input
                  type="date"
                  className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0 text-xs"
                  value={tempDateRange.end}
                  min={tempDateRange.start}
                  max={getDefaultDateRange().end}
                  onChange={e => setTempDateRange(r => ({ ...r, end: e.target.value }))}
                />
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleDateRangeSearch}
                className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40"
              >Buscar</button>
              <button
                onClick={handleExportToExcel}
                className="flex justify-center items-center bg-green-600 h-5 px-4 rounded-2xl text-white gap-2 w-40"
                title="Exportar para Excel"
              >
                <FaFileExcel />
                <span className="hidden sm:inline">Exportar</span>
              </button>
            </div>
          </div>
          <div className="w-full">
            <div className="flex gap-1 ms-2 text-[10px]">Total: <div className="font-bold">{myCollectsList?.totalCollectOrders} registros</div></div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg text-[9px]">
                  <thead className="bg-zinc-700 text-white">
                    <tr>
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID Coleta</th>
                      <th className="py-2 px-4 border-b">Solicitação Ref</th>
                      <th className="py-2 px-4 border-b">Tipo Coleta</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">GMO</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Equipamento</th>
                      <th className="py-2 px-4 border-b">Qtdade Coleta</th>
                      <th className="py-2 px-4 border-b">Endereço</th>
                      <th className="py-2 px-4 border-b">Complemento</th>
                      <th className="py-2 px-4 border-b">Contato</th>
                      <th className="py-2 px-4 border-b">Telefone</th>
                      <th className="py-2 px-4 border-b">SLA Coleta</th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myCollectsList?.collectOrders?.map((collectOrder, index) => (
                      <tr key={index} className="border-b hover:bg-gray-100">
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                            <FaCircle
                              className="animate-pulse"
                              color={StatusCollectOrders[`${collectOrder?.status}`]?.cor}
                              size={15}
                            />
                            {collectOrder?.status}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={() => handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder?.idCollectOrder}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest ? collectOrder?.idRequest : 'AVULSO'}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{getDescricaoByCod(collectOrder?.tipoColeta)}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{formatDate(parseISO(collectOrder?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder.gmo.cidade === "SÃO PAULO" ? `SP - ${collectOrder.gmo.identificador}` : `${collectOrder.gmo.cidade}`}</div></td>
                        <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{collectOrder?.codEquipamentoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.nomeEquipamentoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColeta}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColetaComplemento}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.nomeSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.contatoSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.slaCollectDate ? formatDate(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : ""}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">
                          <button
                            className="bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                            onClick={() => { handleCollectOrderGE(collectOrder._id) }}
                          >
                            Gerar GE
                          </button>
                          {collectOrder?.status === 'ABERTO' && ehUsuarioInterno(user) &&
                            <button
                              className="bg-amber-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => handleCancel(collectOrder._id)}
                            >
                              Cancelar
                            </button>
                          }
                        </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Paginação Minhas Coletas - padrão ConsultaGerencialAtendimento */}
              <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChangeMyCollects(currentPageMyCollects - 1)}
                  disabled={currentPageMyCollects === 1}
                  className={`px-2 py-1 rounded-md ${currentPageMyCollects === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>
                {/* Primeira página */}
                {currentPageMyCollects > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChangeMyCollects(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageMyCollects >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}
                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageMyCollects - 1 + i;
                  if (page > 0 && page <= (myCollectsList?.totalPages || 1)) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChangeMyCollects(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageMyCollects ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}
                {/* Última página */}
                {currentPageMyCollects < (myCollectsList?.totalPages || 1) - 1 && (
                  <>
                    {currentPageMyCollects < (myCollectsList?.totalPages || 1) - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChangeMyCollects(myCollectsList?.totalPages || 1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {myCollectsList?.totalPages || 1}
                    </button>
                  </>
                )}
                <button
                  onClick={() => handlePageChangeMyCollects(currentPageMyCollects + 1)}
                  disabled={currentPageMyCollects === (myCollectsList?.totalPages || 1)}
                  className={`px-2 py-1 rounded-md ${currentPageMyCollects === (myCollectsList?.totalPages || 1) ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>
            </div>
          </div>

      </div>

      {initiateReverseModal &&
        <div className="absolute">
          <InitiateReverseModal
            isModalOpen={initiateReverseModal}
            setModalOpen={() => {
              setInitiateReverseModal(!initiateReverseModal);
            }}
            reverseId={reverseOnAnswerModal}
          ></InitiateReverseModal>
        </div>
      }

      {initiateSingleCollectModal &&
        <div className="absolute">
          <InitiateSingleCollectOrderModal
            isModalOpen={initiateSingleCollectModal}
            setModalOpen={() => {
              setInitiateSingleCollectModal(!initiateSingleCollectModal);
            }}
          ></InitiateSingleCollectOrderModal>
        </div>
      }

      {collectOrderOnGenerateGEModalModal &&
        <div className="absolute">
          <GenerateGEModal
            isModalOpen={generateGEModal}
            setModalOpen={() => {
              setGenerateGEModal(!generateGEModal);
            }}
            collectOrderId={collectOrderOnGenerateGEModalModal}
          ></GenerateGEModal>
        </div>
      }

      {collectOrderOnDetailsModal &&
        <div className="absolute">
          <CollectOrderDetailsModal
            isModalOpen={collectOrderDetailsModal}
            setModalOpen={() => {
              setCollectOrderDetailsModal(!collectOrderDetailsModal);
            }}
            collectOrderId={collectOrderOnDetailsModal}
          ></CollectOrderDetailsModal>
        </div>
      }

      {collectOrderOnCancelModal &&
        <div className="absolute">
          <CancelCollectOrderModal
            isModalOpen={cancelModal}
            setModalOpen={() => {
              setCancelModal(!cancelModal);
            }}
            collectOrderId={collectOrderOnCancelModal}
          ></CancelCollectOrderModal>
        </div>
      }
    </div>
  );
}